export enum SiteCostType {
  PATIENT_INVOICEABLES = 'patient_invoiceables',
  PATIENT_VISITS = 'patient_visits',
  SITE_INVOICEABLES = 'site_invoiceables',
}
